import script from "./AppGroupDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AppGroupDetail.vue?vue&type=script&setup=true&lang=js"

import "./AppGroupDetail.vue?vue&type=style&index=0&id=21edbfdd&lang=css"

const __exports__ = script;

export default __exports__